import Tr from 'translations/Translations';

export const OfferChoiceResultState = {
    NEW: "NEW",
    PUBLISHED: "PUBLISHED",
    WITHDRAWN: "WITHDRAWN"
}
const _TR_PREFIX = 'offer_choice_result_state_';

export const OfferChoiceResultStateLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
